import { commonUtil } from '@/util'
const request = {}

request.createRequest = function (params) {
  return {
    ecReceiveOrderId: params.ecReceiveOrderId,
    customerId: params.customerId,
    currencyId: params.currencyId,
    isAutoShip: params.isAutoShip
  }
}
export default { request }
